import React from "react";
import { connect } from "react-redux";
import { Message } from "primereact/message";

import { hasRight } from "../Utils/rights";

/**
 * Guarda de autorização no nível da ROTA.
 *
 * POR QUE EXISTE (TD-031)
 * -----------------------
 * Até aqui, o direito de ver uma tela administrativa era checado onde o botão do menu é desenhado
 * (`SideMenu`). Isso responde "mostro o botão?", não "essa pessoa pode entrar?" — quem digitasse a
 * URL entrava. Não havia vazamento entre agências (o backend escopa os dados pelo token), mas um
 * usuário criado SEM o direito de listar reservas alcançava a tela de reservas da própria agência.
 *
 * Consertar tela a tela é remendo: resolve as que alguém lembrou de auditar e deixa passar as que
 * ninguém auditou — e todas as futuras. Aqui a regra fica ao lado da rota, em `routes.js`, que é
 * onde alguém olha quando pergunta "quem pode ver isso?".
 *
 * ISTO NÃO É SEGURANÇA, É COERÊNCIA DE INTERFACE. Guarda de rota vive no cliente e pode ser
 * contornada por quem quiser. Quem protege dado é o backend, que já escopa e responde 403. O que
 * esta guarda garante é que a interface não ofereça o que a pessoa não pode fazer — e que o
 * "acesso negado" apareça como mensagem, não como tela quebrada ou lista vazia inexplicável.
 *
 * USO em `routes.js`:
 *   { path: "/admin/reservations", right: "listBookings", ... }   // exige o direito
 *   { path: "/admin/cancelamento-automatico", masterOnly: true }  // exclusivo da SMI
 *
 * Rota sem `right` nem `masterOnly` passa direto — é o caso da maioria, e o silêncio aqui significa
 * "qualquer usuário autenticado", não "esqueceram de declarar".
 */
const RouteGuard = (props) => {
	const { route, masterUser, userRights, children } = props;

	const exigeMaster = !!route?.masterOnly;
	const direito = route?.right || null;

	// `hasRight` já trata o direito "all" como coringa, então master com "all" passa por ele.
	// O `masterUser ||` cobre o caso de o perfil master não carregar "all" na lista.
	const permitido =
		(!exigeMaster || masterUser) &&
		(!direito || masterUser || hasRight(userRights, direito));

	if (permitido) return children;

	return (
		<div style={{ padding: "40px", maxWidth: 720, margin: "0 auto" }}>
			<Message
				severity="warn"
				style={{ width: "100%" }}
				text={exigeMaster
					? "Acesso restrito: esta área é operada pela SMI."
					: "Acesso restrito: seu usuário não tem permissão para esta tela. Fale com o administrador da sua agência."}
			/>
		</div>
	);
};

const mapState = (s) => ({
	masterUser: s.appReducer?.masterUser,
	userRights: s.appReducer?.userRights
});

export default connect(mapState)(RouteGuard);
